import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

/**
 * Mobile-only tab picker for modal tab strips — mirrors the main app's mobile
 * page navigation pattern: on small screens the horizontal tab strip is
 * replaced by a single full-width dropdown showing the current tab.
 *
 * Props:
 *  - tabs     [{ value, label, icon }]  (icon = rendered element, optional)
 *  - value    current tab value
 *  - onChange fn(value) — parent handles any per-tab side effects
 */
export const MobileTabPicker = ({ tabs, value, onChange, testId = 'mobile-tab-picker' }) => (
  <div className="sm:hidden px-4 pt-3 pb-1 flex-shrink-0 border-b">
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full h-11 text-base font-bold mb-2" data-testid={testId}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="z-[10001]">
        {tabs.map((t) => (
          <SelectItem key={t.value} value={t.value} className="min-h-[44px] text-base py-2.5" data-testid={`${testId}-${t.value}`}>
            <span className="flex items-center gap-2.5 font-bold">{t.icon}{t.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
